import { Segment } from "../../models/Segment";

export const REQUEST_SEGMENTS = "REQUEST_SEGMENTS";

export interface FetchSegments {
  type: typeof REQUEST_SEGMENTS;
  payload: ReadonlyArray<Segment>;
}

export type SegmentActionTypes = FetchSegments;

export interface SegmentState {
  segments: ReadonlyArray<Segment>;
}
